export default {
  title: 'Системные журналы',
  source: 'Подключено к экземпляру: {{instanceId}} · Файл: {{fileName}}',
  instances: 'Экземпляры',
  localInstance: '{{instanceId}} (подключён)',
  instanceLost: 'Этот экземпляр перестал отправлять свой журнал (остановлен или недоступен)',
  status: {
    connecting: 'Подключение...',
    connected: 'В реальном времени',
    disconnected: 'Отключено',
  },
  searchPlaceholder: 'Фильтр строк...',
  levels: {
    error: 'Ошибка',
    warn: 'Предупреждение',
    info: 'Инфо',
    debug: 'Отладка',
  },
  httpRequests: 'HTTP-запросы',
  httpRequestsTitle: 'Показать или скрыть строки журнала HTTP-запросов, обработанных сервером',
  maxLines: 'Макс. строк',
  pause: 'Пауза',
  resume: 'Продолжить (новых: {{count}})',
  export: 'Экспорт',
  exportTitle: 'Скачать все загруженные строки (без учёта фильтров) в текстовый файл',
  clear: 'Очистить',
  reconnect: 'Переподключиться',
  jumpToLatest: 'К последним',
  fileNotFound: 'Экземпляр {{instanceId}}: файл журнала {{fileName}} не найден, ожидание его создания',
  linesCount: 'Показано {{visible}} из {{total}} строк',
  markers: {
    rotated: 'выполнена ротация файла журнала',
    skipped: 'записано слишком много строк: часть строк пропущена',
    truncated: 'более старые строки не загружены',
  },
}
